export const size = {
    extraSmall: '2px',
    small: '4px',
    mediumSmall: '6px',
    medium: '8px',
    mediumLarge: '12px',
    large: '14px',
    extraLarge: '16px',
    huge: '32px',
};

export const padding = {
    extraSmall: size.extraSmall,
    small: size.small,
    medium: size.medium,
    large: size.large,
    extraLarge: size.extraLarge,
    huge: size.huge,
};
